import { AuditOutlined } from '@ant-design/icons';
import { DeskDocument } from 'client/api/backend/schemas';
import { DeskWidgetsLogic } from 'client/components/schema/desk/logic/DeskWidgetsLogic';
import { createToolkitAction } from 'client/components/toolkit/actions/ToolkitAction';
import { IToolkitActionContext } from 'client/components/toolkit/actions/ToolkitActionContext';
import { ToolkitObject } from 'client/components/toolkit/objects/ToolkitObject';
import { DocumentToolkitObject } from 'client/components/widget-repository/objects/documents/DocumentToolkitObject';
import React from 'react';
import { WidgetDocumentSendToProtocolQueueType } from '../WidgetDocumentSendToProtocolQueue.type';
import { WidgetDocumentSendToProtocolQueueProfile } from '../WidgetDocumentSendToProtocolQueueProfile';

export const WidgetActionSendToProtocolQueue = createToolkitAction({
  name: 'Invio alla Coda di Protocollazione',
  code: 'send-to-protocol-queue',
  icon: <AuditOutlined />,
  showInBar: true, // Necessario per "allowClickToStart"
  allowClickToStart: false, // Il primo argument sarà `null`
  arguments: [
    {
      name: 'Documento da inviare alla Coda di Protocollazione',
      type: [DocumentToolkitObject],
      allows: (document: ToolkitObject<DeskDocument>) =>
        document.data.protocolNumber == null && document.data.mode == null
    }
  ],
  async execute(ctx: IToolkitActionContext, object: ToolkitObject) {
    const document = DocumentToolkitObject.get(object);

    if (!document) {
      await ctx.deskContext.createWidget(
        {
          type: 'floating',
          expanded: true,
          order: DeskWidgetsLogic.getFloatingNextOrder(
            ctx.deskContext.floatingWidgets
          )
        },
        WidgetDocumentSendToProtocolQueueType,
        { quickClose: true }
      );
      return;
    }

    // Se esiste il documento, lo apriamo
    const data: WidgetDocumentSendToProtocolQueueProfile = {
      document: document.data,
      sourceWidgetId: ctx.sourceWidget?.id
    };

    await ctx.deskContext.cloneWidget(
      {
        type: 'floating',
        expanded: true,
        order: DeskWidgetsLogic.getFloatingNextOrder(
          ctx.deskContext.floatingWidgets
        )
      },
      WidgetDocumentSendToProtocolQueueType,
      ctx.sourceWidget!,
      { quickClose: true, data }
    );
  }
});
